import { useEffect } from "react";
import spaceStore from "../../store/spaceStore";
import { useParams, useSearchParams } from "react-router-dom";
import MainContent from "../../components/Spark/MainContent/MainContent";
import { queryClient } from "../../api/index";
import QUERYKEYS from "../../api/queryKeys";

const SpectraChatPage = () => {
  const setOpenSpectraId = spaceStore((state) => state.setOpenSpectraId);
  const space_id = useParams().space_id;
  const [searchParams] = useSearchParams();

  useEffect(() => {
    setOpenSpectraId(space_id);
  }, [space_id, setOpenSpectraId]);

  useEffect(() => {
    if (searchParams.get("q") === "SHARED") {
      queryClient.invalidateQueries({ queryKey: [QUERYKEYS.SPECTRAS] });
    }
  }, [searchParams]);

  return <MainContent space_id={space_id} />;
};

export default SpectraChatPage;
